import { LegalPageLayout, COMPANY_INFO } from './LegalPage';

const CGV = () => {
  return (
    <LegalPageLayout title="Conditions Générales de Vente">
      <h2>Article 1 — Objet</h2>
      <p>
        Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre
        {' '}{COMPANY_INFO.name}, exploitant du restaurant <strong>NotaBene Sympho</strong> situé à{' '}
        {COMPANY_INFO.address}, et toute personne (ci-après « le Client ») souhaitant passer une commande
        de plats à emporter, en livraison, ou réserver une table via le site internet
        <strong> notabenesympho.be</strong>.
      </p>

      <h2>Article 2 — Commandes</h2>
      <p>
        Le Client peut passer commande en ligne via la page « Commander ». Toute commande validée
        implique l'acceptation pleine et entière des présentes CGV. Le restaurant se réserve le droit
        de refuser une commande en cas de rupture de stock, zone hors livraison, ou tout motif légitime.
        Dans ce cas, le Client sera informé par email et, le cas échéant, remboursé intégralement.
      </p>

      <h2>Article 3 — Prix</h2>
      <p>
        Les prix affichés sur le site sont exprimés en euros (€), TVA belge comprise. Le restaurant se
        réserve le droit de modifier ses prix à tout moment, étant toutefois entendu que le prix figurant
        au moment de la validation de la commande sera le seul applicable au Client.
      </p>
      <p>
        Des frais de livraison peuvent être appliqués selon la zone desservie. Un montant minimum de
        commande peut être requis pour la livraison.
      </p>

      <h2>Article 4 — Livraison et retrait</h2>
      <p>
        La livraison est assurée uniquement dans les codes postaux indiqués dans la page « Commander ».
        Le délai de livraison annoncé est indicatif. En cas de retard exceptionnel,
        la responsabilité du restaurant se limitera au remboursement des frais de livraison.
      </p>
      <p>
        Pour les commandes à emporter, le Client doit se présenter au restaurant à l'heure souhaitée
        indiquée lors de la commande.
      </p>

      <h2>Article 5 — Paiement</h2>
      <p>
        Le paiement s'effectue :
      </p>
      <ul>
        <li><strong>En ligne par carte bancaire</strong> via la plateforme sécurisée Stripe (transaction
          chiffrée SSL).</li>
        <li><strong>En espèces</strong> au moment de la livraison ou du retrait.</li>
      </ul>
      <p>
        En cas de paiement en ligne, la commande est ferme et définitive dès validation du paiement par
        la banque émettrice. Aucune donnée bancaire n'est stockée sur nos serveurs.
      </p>

      <h2>Article 6 — Droit de rétractation</h2>
      <p>
        Conformément à l'article VI.53 du Code de droit économique belge, le droit de rétractation <strong>ne
        s'applique pas</strong> aux contrats de fourniture de biens alimentaires susceptibles de se détériorer rapidement.
        Les commandes validées sont donc <strong>fermes et définitives</strong> et ne peuvent faire l'objet ni d'un échange
        ni d'un remboursement, sauf erreur ou vice imputable au restaurant.
      </p>

      <h2>Article 7 — Annulation par le Client</h2>
      <p>
        Une commande peut être annulée gratuitement jusqu'à 30 minutes après sa validation, sous
        réserve que la préparation n'ait pas commencé. Passé ce délai, aucun remboursement ne pourra être exigé.
      </p>
      <p>
        Pour les réservations de table, toute annulation doit être signalée au minimum 2 heures avant l'heure prévue,
        par téléphone au {COMPANY_INFO.phone}.
      </p>

      <h2>Article 8 — Allergènes et sécurité alimentaire</h2>
      <p>
        La liste des allergènes présents dans nos plats est disponible sur demande. Le Client est invité à signaler
        au restaurant toute allergie alimentaire lors de la commande. Le restaurant met tout en œuvre pour respecter
        les normes d'hygiène HACCP en vigueur en Belgique.
      </p>

      <h2>Article 9 — Responsabilité</h2>
      <p>
        La responsabilité de {COMPANY_INFO.name} ne saurait être engagée en cas d'inexécution ou de mauvaise
        exécution du contrat du fait du Client ou d'un cas de force majeure (grève, intempérie, panne technique,
        coupure internet, etc.).
      </p>

      <h2>Article 10 — Données personnelles</h2>
      <p>
        Les informations collectées lors des commandes et réservations sont traitées conformément à notre{' '}
        <a href="/politique-confidentialite" className="text-[#C62E2E]">Politique de confidentialité</a>{' '}
        (RGPD).
      </p>

      <h2>Article 11 — Litiges et droit applicable</h2>
      <p>
        Les présentes CGV sont soumises au droit belge. En cas de litige, le Client est invité à contacter
        préalablement le restaurant à l'adresse {COMPANY_INFO.email} afin de rechercher une solution amiable.
        À défaut, les tribunaux de l'arrondissement judiciaire de Mons seront seuls compétents.
      </p>
      <p>
        Le Client peut également recourir à la plateforme européenne de règlement en ligne des litiges :{' '}
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#C62E2E]">
          https://ec.europa.eu/consumers/odr
        </a>.
      </p>
    </LegalPageLayout>
  );
};

export default CGV;
